import { placeholderImg } from '../../../utils/links';

const ChildImage = ({ img, thumbnail, altText }) => {

    return <div className={`img ${img?.animation}`}>
        <img className="rounded" src={thumbnail || placeholderImg} alt={altText} />
    </div>
}
export default ChildImage;